/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import numeral from 'numeral'

export const formatNumber = (num: number, format = '0a') => {
  return numeral(num).format(format)
}
